export default "__VITE_ASSET__DOEZ2hk8__"